import { Component, View, ViewModel, ViewModelMessage } from "binder";
import  { OverlayView } from "./overlay-view"

export class OverlayViewModel extends Component{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.showing=false;
        this.contentwidth='80%';
        this.contentheight='80%';
    }
    GetDefaultView(): View <ViewModel> {
        return new OverlayView();
    }
    public getTypeId(): string {
        return "VM-98633AF7-B9DB-408F-B54A-45B34CB0C143"
    }
    
    public set showing(v: boolean) { this._showing = v; } public get showing(): boolean { return this._showing;} private _showing: boolean;
    public set contentwidth(v: string) { this._contentwidth = v; } public get contentwidth(): string { return this._contentwidth;} private _contentwidth: string;
    public set contentheight(v: string) { this._contentheight = v; } public get contentheight(): string { return this._contentheight;} private _contentheight: string;

    requestClosing() {
        if(this.showing){
            this.handleMessage(new overlayRequestsClosingMessage())
        }
    }
}

export class overlayRequestsClosingMessage extends ViewModelMessage{

}